module.exports = __webpack_public_path__ + "static/media/unify.fe566be2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/recollect/unify.mp4
// module id = 353
// module chunks = 0